/* eslint-disable react/jsx-no-target-blank */

import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const ExternalLink = forwardRef(({ href, target, ...rest }, ref) => {
  return (
    <a
      href={href}
      target={target ? target : '_blank'}
      rel="noopener"
      ref={ref}
      {...rest}
    />
  )
})

ExternalLink.displayName = 'ExternalLink'

ExternalLink.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
}
